// extracted by mini-css-extract-plugin
module.exports = {"linkPreviewText":"profile_linkPreviewText__t9AVs","linkPreviewImage":"profile_linkPreviewImage__rnjcw"};